
    <a [routerLink]="url">
      <i class="table-edit-btn fas fa-edit"></i>
      <span [innerHTML]="renderValue"></span>
    </a>